/* src/app/shared/components/certificate-form/certificate-form.component.scss */
.certAreaItem {
  margin-top: 7px;
  width: 50%;
  display: flex;
}
.span-spacer {
  flex: 1 1 auto;
}
.half-width {
  width: 50%;
}
.full-width {
  width: 100%;
}
/*# sourceMappingURL=certificate-form.component.css.map */
